import { Stack } from 'expo-router';
import { useMutation } from 'urql';
import DestructiveAction, {
  DestructiveActionDescription,
  DestructiveActionHeading,
} from '@/components/Custom/DestructiveAction';
import ContentBoundary from '@/components/UI/ContentBoundary';
import EmptyPlaceholder from '@/components/UI/EmptyPlaceholder';
import { graphql } from '@/gql/graphql';
import useCurrentUser from '@/hooks/useCurrentUser';
import useSignOut from '@/hooks/useSignOut';

const DeleteUser = graphql(/* GraphQL */ `
  mutation DeleteUser {
    deleteUser {
      id
    }
  }
`);
export default function ProfileDelete() {
  const [, deleteUser] = useMutation(DeleteUser);
  const user = useCurrentUser();
  const signOut = useSignOut();
  const onPressDelete = async () => {
    const result = await deleteUser({});
    if (result.error || !result.data?.deleteUser) return { success: false };
    return { success: true };
  };
  return (
    <>
      <Stack.Screen options={{ title: 'Delete Account' }} />
      <ContentBoundary
        data={user?.username || null}
        empty={<EmptyPlaceholder message="Account deletion is unavailable." />}
      >
        {(username) => (
          <DestructiveAction
            key={username}
            confirmationName={username}
            label="Delete Account"
            submittingLabel="Deleting…"
            testID="ProfileDeleteConfirmButton"
            onAction={onPressDelete}
            onSuccess={signOut}
          >
            <DestructiveActionHeading>
              Are you sure you want to delete your account?
            </DestructiveActionHeading>
            <DestructiveActionDescription>
              This cannot be undone. We cannot recover your account once you
              delete it.
            </DestructiveActionDescription>
          </DestructiveAction>
        )}
      </ContentBoundary>
    </>
  );
}
